import { IconProps } from 'types/icon.type'

export const SearchResultsIcon = (props: IconProps) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Search Results Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 14C5.25 13.0335 6.0335 12.25 7 12.25H49C49.9665 12.25 50.75 13.0335 50.75 14C50.75 14.9665 49.9665 15.75 49 15.75H7C6.0335 15.75 5.25 14.9665 5.25 14ZM5.25 28C5.25 27.0335 6.0335 26.25 7 26.25H23.3333C24.2998 26.25 25.0833 27.0335 25.0833 28C25.0833 28.9665 24.2998 29.75 23.3333 29.75H7C6.0335 29.75 5.25 28.9665 5.25 28ZM5.25 42C5.25 41.0335 6.0335 40.25 7 40.25H23.3333C24.2998 40.25 25.0833 41.0335 25.0833 42C25.0833 42.9665 24.2998 43.75 23.3333 43.75H7C6.0335 43.75 5.25 42.9665 5.25 42Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.6667 29.75C36.7672 29.75 34.4167 32.1005 34.4167 35C34.4167 37.8995 36.7672 40.25 39.6667 40.25C42.5662 40.25 44.9167 37.8995 44.9167 35C44.9167 32.1005 42.5662 29.75 39.6667 29.75ZM30.9167 35C30.9167 30.1675 34.8342 26.25 39.6667 26.25C44.4992 26.25 48.4167 30.1675 48.4167 35C48.4167 39.8325 44.4992 43.75 39.6667 43.75C34.8342 43.75 30.9167 39.8325 30.9167 35Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.3292 38.6626C44.0126 37.9791 45.1207 37.9791 45.8041 38.6626L50.2374 43.0959C50.9209 43.7793 50.9209 44.8874 50.2374 45.5708C49.554 46.2542 48.446 46.2542 47.7626 45.5708L43.3292 41.1374C42.6458 40.454 42.6458 39.346 43.3292 38.6626Z"
        fill="currentColor"
      />
    </svg>
  )
}
